import { useState, useEffect, useCallback } from "react";
import { getUserJiraProfile, updateAtlassianDisplayName } from "../api/profileClient";
import { UserJiraProfileDto } from "../api/models/UserJiraProfileDto";

export const useEditProfile = () => {
  const [profile, setProfile] = useState<UserJiraProfileDto | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const loadProfile = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getUserJiraProfile();
      setProfile(data);
    } catch {
      setError("Failed to load profile data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  const saveDisplayName = async (displayName: string) => {
    setIsSaving(true);
    setError(null);
    setSaveSuccess(false);
    try {
      await updateAtlassianDisplayName(displayName);
      setProfile((prev) => prev ? { ...prev, atlassianDisplayName: displayName } : prev);
      setSaveSuccess(true);
    } catch {
      setError("Failed to update Atlassian display name. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return {
    profile,
    isLoading,
    isSaving,
    error,
    saveSuccess,
    saveDisplayName,
  };
};
